<template>
  <component
    :is="linkTag"
    v-if="!hidden"
    v-bind="linkProps"

    :class="[
      'btn',
      icon ? `btn--${negative ? 'negative' : 'positive'}` : '',
      `btn--${button || 'secondary'}`,
      `btn--${size || 'm'}`,
      {
        'btn--icon': icon,
        'btn--idle': (!hover && !isHover && !active && !isActive) || (loadingSet),
        'btn--hover': (hover ||isHover || active || isActive) && !disabledSet && !loadingSet,
        'btn--active': (active || isActive) && !disabledSet && !hover && !loadingSet,
        'btn--disabled': !success && !loadingSet && disabledSet,
        'btn--loading': loadingSet,
        'btn--success': successSet,
      }
    ]"

    :disabled="disabledSet || loadingSet || successSet"

    @mouseover="onMouseEnter"
    @mouseleave="onMouseLeave"
    @mousedown.prevent="onMouseDown"
    @click="onClick"
  >
    <b 
      :style="{ 'background-color': org.custom_color1 == null ? '': org.custom_color1 }"
      class="btn__bg"
      aria-hidden="true" />
    <module-dots
      :class="`btn__dots`"
      
      :active="loadingSet" />
    <!-- <module-icon :class="`btn__success`" icon="tick" /> -->
    <span class="btn__inner">
      <span class="btn__content">
        <span class="btn__label">
          {{ label || `` }}<slot v-if="!label"/>
        </span><!--
        --><module-icon v-if="icon" :class="`btn__icon`" :icon="icon" />
      </span>
    </span>
  </component>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';

// Utils
import { getLinkTag, getLinkType, createLinkProps } from 'utils/link';

// Modules
import ModuleIcon from 'components/Icon';
import ModuleDots from 'components/Dots';

// Other
import VueScrollTo from 'vue-scrollto';

// Export
export default {
  name: 'module-button',

  // Components
  components: {
    ModuleIcon,
    ModuleDots,
  },

  // Props
  props: {
    active: Boolean,
    hover: Boolean,
    disabled: Boolean,
    loading: Boolean,
    label: String,
    success: Boolean,
    button: {
      type: String,
    },
    icon: String,
    link: [
      String,
      Object,
    ],
    negative: Boolean,
    title: String,
    size: {
      type: String,
    },
    form: {
      type: String,
    },
    hidden: Boolean,
    emit: Boolean,
    value: [String, Number, Object, Array, Boolean],
  },

  // Data
  data() {
    return {
      isActive: false,
      isHover: false,
    };
  },
  computed: {
    ...mapGetters('app', ['org']),
    ...mapGetters('forms', [
      'getForm',
    ]),
    linkType() {
      return getLinkType(this.link);
    },
    linkTag() {
      return getLinkTag(this.link);
    },
    linkProps() {
      return createLinkProps(this.link, '', this.title);
    },
    formState() {
      return this.form ? (this.getForm(this.form) || {}).state : '';
    },
    disabledSet() {
      return this.disabled || this.formState === 'invalid';
    },
    loadingSet() {
      return this.loading || this.formState === 'loading';
    },
    successSet() {
      return this.success || this.formState === 'success';
    },
  },

  // Methods
  methods: {
    onMouseEnter() {
      this.isHover = true;
    },
    onMouseLeave() {
      this.isHover = false;
    },
    onMouseDown() {
      this.isActive = true;
    },
    onMouseUp() {
      this.isActive = false;
      this.isHover = false;
    },
    onClick(e) {
      if (this.linkType === 'anchor') {
        e.preventDefault();
        VueScrollTo.scrollTo(this.link, 500, {});
      }

      if (this.emit) {
        e.preventDefault();
        this.$emit('parentAction', this.value);
      }
    },
  },

  // Lifecycle
  mounted() {
    document.addEventListener('mouseup', this.onMouseUp, false);
  },
  destroyed() {
    document.removeEventListener('mouseup', this.onMouseUp, false);
  },
};
</script>



// WEBPACK FOOTER //
// Button.vue?1f15e04e